import { useHistory, useLocation } from 'react-router-dom';

import { TranslatableText } from '@dreryk/react-common';
import { Chip, ClearIcon, TestId } from '@dreryk/react-components';

type ChipFilterProps = {
   readonly label: TranslatableText;
   readonly searchParamKey: string;
   readonly testId: TestId;
   readonly onClick?: VoidFunction;
   readonly hideExcessiveLabel?: boolean;
};

const ChipFilter = (props: ChipFilterProps): JSX.Element => {
   const location = useLocation();
   const history = useHistory();

   const onClick = (): void => {
      const queryParams = new URLSearchParams(location.search);
      queryParams.delete(props.searchParamKey);
      history.replace({
         search: queryParams.toString(),
         state: location.state,
      });
      props.onClick?.();
   };

   return (
      <Chip
         testId={props.testId}
         label={props.label}
         onClick={onClick}
         icon={<ClearIcon />}
         hideExcessiveLabel={props.hideExcessiveLabel}
      />
   );
};

export { ChipFilter };
